import {
  Drawer,
  DrawerProps,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import { ReactNode } from 'react';

export interface SidebarMenuItem {
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  href?: string;
  divider?: boolean;
}

export interface SidebarProps extends DrawerProps {
  items?: SidebarMenuItem[];
  width?: number;
  header?: ReactNode;
  footer?: ReactNode;
}

export const Sidebar = ({
  items = [],
  width = 240,
  header,
  footer,
  children,
  ...props
}: SidebarProps) => {
  return (
    <Drawer
      {...props}
      sx={{
        width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width,
          boxSizing: 'border-box',
        },
        ...props.sx,
      }}
    >
      {header && (
        <>
          <Box sx={{ p: 2 }}>{header}</Box>
          <Divider />
        </>
      )}
      {children || (
        <List>
          {items.map((item, index) => (
            <Box key={index}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={item.onClick}
                  href={item.href}
                  component={item.href ? 'a' : 'div'}
                >
                  {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
              {item.divider && <Divider />}
            </Box>
          ))}
        </List>
      )}
      {footer && (
        <>
          <Box sx={{ flexGrow: 1 }} />
          <Divider />
          <Box sx={{ p: 2 }}>{footer}</Box>
        </>
      )}
    </Drawer>
  );
};

export default Sidebar;
